import { AddressPointSetRequest } from "@1games-ru/region-shared/dist/backend/requests/address";
import { useCallback } from "react";
import CreateEntityMpProvider from "@/core/data-provider/data-mp/create-entity/create-entity-mp-provider";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import toast from "@/domains/toasts/helpers/toast";

export default function useAddressPointSet() {
  const mutateAsync = useCallback(async (data: AddressPointSetRequest) => {
    try {
      const response = await CreateEntityMpProvider.addressPointSet(data);
      if (response instanceof RpcMpProviderSuccessResponse) {
        toast.success("Адрес успешно сохранен");
        return response.data;
      }

      console.log({ data, response });
      toast.error("Ошибка сохранения адреса");
      return false;
    } catch (e) {
      console.log(e);
      toast.error("Ошибка сохранения адреса");
      return false;
    }
  }, []);

  return {
    mutateAsync,
  };
}
